import groupBy from 'lodash/groupBy';
import { useMemo } from 'react';
import { SuggestionList } from '../SuggestionList/SuggestionList';
import { TabProps } from '../TabProps';
import { SuggestionData } from '../types';
import { useTextSuggestion } from '../useTextSuggestion';
import { treatmentFiltersFromProfiles } from './filtersFromProfiles';
import { sortFiltersByRelevance } from './sortFiltersByRelevance';
import { suggestionsFromFilters } from './suggestionsFromFilters';
import { useSuggestedProfiles } from './useSuggestedProfiles';

export const TreatmentSuggestions = ({ onChoose, searchTerm, trackingData }: TabProps) => {
  const profiles = useSuggestedProfiles(searchTerm);

  const uniqueSuggestions = useMemo(() => {
    const rawFilters = treatmentFiltersFromProfiles(profiles);

    const sortedFilters = sortFiltersByRelevance(rawFilters, searchTerm);

    const rawSuggestions = suggestionsFromFilters(sortedFilters);

    return removeDuplicateSuggestions(rawSuggestions);
  }, [profiles, searchTerm]);

  return (
    <SuggestionList
      onChoose={onChoose}
      suggestions={useTextSuggestion(searchTerm, uniqueSuggestions)}
      trackingData={trackingData}
      searchTerm={searchTerm}
    />
  );
};

export const removeDuplicateSuggestions = (rawSuggestions: SuggestionData[]): SuggestionData[] => {
  const groupedById = groupBy(rawSuggestions, it => it.id);
  const entries = Object.entries(groupedById);
  const firstPerId = entries.flatMap(([, values]) => (values[0] ? [values[0]] : []));
  return firstPerId;
};
